<div class="headerGrid">
  <div>
    <h3 class="fw-bold">Time Off</h3>
    <h3>
      {{ pendingRequestCount | async }} pending request<span
        *ngIf="(pendingRequestCount | async) != 1"
        >s</span
      >
    </h3>
  </div>
  <div class="card">
    <div class="p-2 cardGrid">
      <span> <span class="circle pendingChangeTextBackground me-2"></span>Pending Requests: </span>
      <a (click)="showPendingTable()">{{ pendingRequestCount | async }}</a>
      <span> <span class="circle pendingChangeBackground me-2"></span>Pending Changes: </span>
      <a (click)="showPendingChangeTable()">{{ pendingChangesCount | async }}</a>
      <span> <span class="circle bg-connectpay me-2"></span>Approved: </span>
      <a (click)="showApprovedTable()">{{ approvedCount | async }}</a>
      <span> <span class="circle bg-danger me-2"></span>Declined: </span>
      <a (click)="showDeclinedTable()">{{ declinedCount | async }}</a>
    </div>
  </div>
  <div class="d-flex justify-content-center flex-column">
    <button (click)="submitNewRequest()" class="btn btn-primary">+ Add Time Off</button>
  </div>
</div>
<div class="card" *ngIf="requestsToShow == null && approvedToShow == null">
  <div class="card-body">
    <div class="row">
      <div class="col-4">
        <div class="btn-group">
          <button
            class="btn btn-tertiary"
            [view]="showDayView ? CalendarView.Day : CalendarView.Month"
            mwlCalendarPreviousView
            view="month"
            [(viewDate)]="viewDate">
            <i class="fas fa-chevron-left"></i> Previous
          </button>
          <button
            class="btn btn-secondary"
            [disabled]="isDateInMonth"
            mwlCalendarToday
            [(viewDate)]="viewDate">
            Today
          </button>
          <button
            class="btn btn-tertiary"
            [view]="showDayView ? CalendarView.Day : CalendarView.Month"
            mwlCalendarNextView
            view="month"
            [(viewDate)]="viewDate">
            Next <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
      <div class="col-4 text-center">
        <h3 *ngIf="!showDayView">{{ viewDate | calendarDate: 'monthViewTitle' : 'en' }}</h3>
        <h3 *ngIf="showDayView">{{ viewDate | calendarDate: 'dayViewTitle' : 'en' }}</h3>
      </div>
      <div class="col-4">
        <ng-template #employeeTemplate let-r="result" let-t="term">
          <ngb-highlight [result]="r.FirstName + ' ' + r.LastName" [term]="t"></ngb-highlight>
        </ng-template>
        <div class="input-group search-group mb-0 open">
          <input
            class="form-control narrow-search open square-input searchInput mb-0"
            type="text"
            [ngModel]="searchTerm"
            (ngModelChange)="searchChanged($event)"
            [ngbTypeahead]="search"
            [inputFormatter]="formatter"
            [resultTemplate]="employeeTemplate"
            (focus)="focus$.next($any($event).target.value)"
            (click)="click$.next($any($event).target.value)"
            placeholder="Employee Name"
            #typeahead="ngbTypeahead" />
          <span class="btn btn-primary"><img src="assets/icons/search-white.svg" /></span>
        </div>
      </div>
    </div>
    <div class="mb-2 mt-2" [class.grid]="!showDayView" [class.grid-day]="showDayView">
      <div class="d-flex flex-column justify-content-center" *ngIf="showDayView">
        <button class="btn btn-secondary" (click)="hideDayView()">
          <i class="fas fa-chevron-left"></i> Back to Month View
        </button>
      </div>
      <lib-multiselect
        [options]="statusFilter"
        [ngModel]="currentFilters | async"
        (ngModelChange)="statusFilterChange($event)"></lib-multiselect>
      <div class="d-flex">
        <div
          *ngFor="let filter of statusFilter"
          class="d-flex flex-column justify-content-center me-2">
          <button
            *ngIf="(currentFilters | async).includes(filter.value)"
            (click)="filterPillClicked(filter.value)"
            class="badge rounded-pill border-1 pill-border bg-white">
            {{ filter.value }} <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <button
            *ngIf="(currentFilters | async).length > 0"
            (click)="clearFiltersClicked()"
            class="btn btn-link">
            Clear All
          </button>
        </div>
      </div>
    </div>
    <mwl-calendar-month-view
      *ngIf="!showDayView"
      [viewDate]="viewDate"
      [events]="events | async"
      [refresh]="refresh"
      [activeDayIsOpen]="activeDayIsOpen"
      (dayClicked)="dayClicked($event.day.date)"
      (eventClicked)="eventClicked($event.event)"
      [cellTemplate]="cellTemplate">
    </mwl-calendar-month-view>
    <mwl-calendar-day-view
      *ngIf="showDayView"
      [viewDate]="viewDate"
      [events]="events | async"
      [refresh]="refresh"
      (eventClicked)="eventClicked($event.event)"
      [eventTemplate]="weekTemplate"
      (hourSegmentClicked)="dayClicked($event.date)">
    </mwl-calendar-day-view>
    <ng-template
      #cellTemplate
      let-day="day"
      let-locale="locale"
      let-eventClicked="eventClicked"
      let-trackByEventId="trackByEventId">
      <div
        [class.isPast]="day.isPast"
        class="cal-cell-top"
        [attr.aria-label]="{ day: day, locale: locale } | calendarA11y: 'monthCell'">
        <span aria-hidden="true">
          <span class="cal-day-number">{{
            day.date | calendarDate: 'monthViewDayNumber' : locale
          }}</span>
        </span>
      </div>
      <div
        class="d-flex flex-column justify-content-start m-0"
        [class.isPast]="day.isPast"
        style="align-items: flex-start"
        *ngIf="day.events.length > 0">
        <div *ngIf="parseEventList(day.events).showMore">
          <button (click)="showMore(day); $event.stopPropagation()" class="btn btn-link p-0">
            View All ({{ day.events.length }})
          </button>
        </div>
        <ng-container
          *ngFor="
            let event of parseEventList(day.events).events;
            trackBy: trackByEventId;
            let i = index
          ">
          <div
            class="w-100 p-1 mb-1"
            [class.pendingChangeBackground]="event.meta.EditedByApprover"
            [class.pendingChangeTextBackground]="event.meta.Pending || event.meta.EditedByRequester"
            [class.bg-connectpay]="event.meta.Approved && !event.meta.EditedByApprover"
            [class.bg-danger]="event.meta.Declined"
            [class.startBorder]="AreDatesEqual(day.date, event.start)"
            [class.endBorder]="AreDatesEqual(day.date, event.end) || event.end == null"
            (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })">
            <small class="fw-bold" [class.text-white]="!event.meta.EditedByApprover">
              {{ event.title | calendarEventTitle: 'monthTooltip' : event }}
            </small>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template
      #weekTemplate
      #defaultTemplate
      let-weekEvent="weekEvent"
      let-tooltipPlacement="tooltipPlacement"
      let-eventClicked="eventClicked"
      let-tooltipTemplate="tooltipTemplate"
      let-tooltipAppendToBody="tooltipAppendToBody"
      let-tooltipDisabled="tooltipDisabled"
      let-tooltipDelay="tooltipDelay"
      let-column="column"
      let-daysInWeek="daysInWeek">
      <div
        class="cal-event"
        [ngStyle]="{
          color: getDayViewEventTextColor(weekEvent.event),
          backgroundColor: getDayViewEventBackground(weekEvent.event),
          borderColor: getDayViewEventBorder(weekEvent.event)
        }"
        [mwlCalendarTooltip]="
          !tooltipDisabled
            ? (weekEvent.event.title
              | calendarEventTitle
                : (daysInWeek === 1 ? 'dayTooltip' : 'weekTooltip')
                : weekEvent.tempEvent || weekEvent.event)
            : ''
        "
        [tooltipPlacement]="tooltipPlacement"
        [tooltipEvent]="weekEvent.tempEvent || weekEvent.event"
        [tooltipTemplate]="tooltipTemplate"
        [tooltipAppendToBody]="tooltipAppendToBody"
        [tooltipDelay]="tooltipDelay"
        (mwlClick)="eventClicked.emit({ sourceEvent: $event })"
        (mwlKeydownEnter)="eventClicked.emit({ sourceEvent: $event })"
        tabindex="0"
        role="application"
        [attr.aria-label]="
          { event: weekEvent.tempEvent || weekEvent.event } | calendarA11y: 'eventDescription'
        ">
        <mwl-calendar-event-actions [event]="weekEvent.tempEvent || weekEvent.event">
        </mwl-calendar-event-actions>
        &ngsp;
        <mwl-calendar-event-title
          [event]="weekEvent.tempEvent || weekEvent.event"
          [view]="daysInWeek === 1 ? 'day' : 'week'">
        </mwl-calendar-event-title>
      </div>
    </ng-template>
  </div>
</div>
<lib-open-request-table
  [header]="tableheader"
  *ngIf="requestsToShow != null"
  [requests]="requestsToShow | async"
  [deleted]="deletedToShow | async"
  [edited]="editedToShow | async"
  (showCalendar)="showCalendar()"
  (reviewRequest)="reviewRequestFromTable($event)"
  (reviewEditedRequest)="openEditedModal($event)"
  (reviewDeclinedRequest)="reviewApprovedRequestFromTable($event)"></lib-open-request-table>
<lib-approved-request-table
  *ngIf="approvedToShow != null"
  [requests]="approvedToShow | async"
  (showCalendar)="showCalendar()"
  (reviewRequest)="reviewApprovedRequestFromTable($event)"></lib-approved-request-table>

<ng-template #newRequestModal let-nrModal>
  <lib-client-time-off-request-modal
    (modalClosed)="closeNewRequestModal()"
    *ngIf="showNewRequestModal"
    [clientCode]="clientCode"
    [existingModel]="currentRequest"></lib-client-time-off-request-modal>
</ng-template>

<ng-template #createNewModal let-crModal>
  <lib-client-new-request-modal
    (modalClosed)="closeNewRequestModal()"
    *ngIf="showCreateNewModal"
    [clientCode]="clientCode"
    [defaultDay]="defaultDay"></lib-client-new-request-modal>
</ng-template>

<ng-template #approvedModal let-appModal>
  <lib-client-edit-approved
    (modalClosed)="closeNewRequestModal()"
    *ngIf="showApprovedModal"
    [clientCode]="clientCode"
    [existingModel]="currentApprovedRequest"></lib-client-edit-approved>
</ng-template>
<ng-template #editedRequestModal>
  <lib-employee-request-edited
    *ngIf="showEditedRequestModal"
    [existingModel]="currentEditedRequest"
    [clientCode]="clientCode"
    (modalClosed)="closeNewRequestModal()"></lib-employee-request-edited>
</ng-template>
